<template>
  <button class="cta-route" @click="navigateTo(route, $event)">
    <slot></slot>
  </button>
  <!-- <router-link class="cta-route" @click.native.prevent="navigateTo(route, $event)" :to="{name: route}">
    <slot></slot>
  </router-link> -->
  <!-- <a :href="href" class="cta-button" :target="target">{{buttonText}}</a> -->
</template>
<script>
export default {
  name: 'CTARoute',
  props: ['route'],
  methods: {
    navigateTo (route, event) {
      let done = () => {
        this.$router.push({
          name: this.route
        })
      }

      var btn = event.toElement
      // var para = jQuery(btn).siblings('p')
      // var h2 = jQuery(btn).siblings('h2')
      var section = jQuery(btn).parent()

      var tl = new TimelineMax({paused: true, onComplete: done})

      tl.add('start')
        .to(section, 0.6, {autoAlpha: 0, y: -100, ease: Power0.easeOut})
        // .to(para, 0.6, {autoAlpha: 0, y: -100, ease: Power0.easeOut}, 'start+=0.1')
        // .to(btn, 0.6, {autoAlpha: 0, y: -100, ease: Power0.easeOut}, 'start+=0.2')
      tl.play()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
.cta-route {
  display: inline-block;
  background: $blue;
  color: $white;
  padding: 16px 24px;
  text-decoration: none;
  cursor: pointer;
  border: none;
  font-family: "Arial W01", sans-serif;
  font-size: 15px;
  &:hover {
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,.07);
  }
  &:active {
    color: #2c7899;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CTARoute.vue